var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "10px" } },
    [
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: { size: "mini" },
        },
        [
          _c(
            "el-row",
            { staticStyle: { padding: "10px 0" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: (_vm.colSpan * 4) / 6 } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.IRActive"))),
                  ]),
                  _vm._v("："),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        color: "darkslateblue",
                      },
                    },
                    [_vm._v(_vm._s(_vm.dataInfo.summary.activeClientQty || 0))]
                  ),
                ]),
              ]),
              _c("el-col", { attrs: { span: (_vm.colSpan * 4) / 6 } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.IRLeave"))),
                  ]),
                  _vm._v("："),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        color: "darkslateblue",
                      },
                    },
                    [_vm._v(_vm._s(_vm.dataInfo.summary.leaveClientQty || 0))]
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { padding: "10px 0" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: (_vm.colSpan * 4) / 6 } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.IRNew"))),
                  ]),
                  _vm._v("："),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        color: "darkslateblue",
                      },
                    },
                    [_vm._v(_vm._s(_vm.dataInfo.summary.newClientQty || 0))]
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vxe-table",
        {
          staticStyle: { margin: "20px -10px 10px" },
          attrs: {
            border: "",
            data: _vm.dataInfo.clientInfos,
            "empty-text": _vm.$t("table.emptyText"),
            "sort-config": { defaultSort: _vm.defaultSort },
          },
          on: { "sort-change": _vm.sortChangeEvent },
        },
        [
          _c("vxe-column", {
            attrs: {
              field: "clientCode",
              title: _vm.$t("billingPage.IRClientCode"),
              sortable: "",
            },
          }),
          _c("vxe-column", {
            attrs: {
              field: "companyName",
              title: _vm.$t("billingPage.companyName"),
              sortable: "",
            },
          }),
          _c("vxe-column", {
            attrs: {
              field: "effectiveDate",
              title: _vm.$t("billingPage.effectiveDate"),
              sortable: "",
            },
          }),
          _c("vxe-column", {
            attrs: {
              field: "startDate",
              title: _vm.$t("form.startDateText"),
              sortable: "",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: { size: "mini" },
        },
        [
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-data": _vm.lineChartDataLine1,
                      height: "350px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-data": _vm.lineChartDataLine2,
                      height: "350px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-data": _vm.lineChartDataLine3,
                      height: "350px",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          staticStyle: { "padding-top": "50px" },
          attrs: { size: "mini" },
        },
        [
          _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
            _c("b", [_vm._v(_vm._s(_vm.$t("billingPage.IRTPMM")))]),
          ]),
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataBar1 },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataPie1 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }